import React, { useState, useCallback } from 'react'
import { Layout, Menu, Avatar, Button, Dropdown } from 'antd'
import {
  DashboardOutlined,
  BarChartOutlined,
  UserOutlined,
  SettingOutlined,
  CreditCardOutlined,
  FormOutlined,
} from '@ant-design/icons'
import { Link, Outlet, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import Filters from '@/components/Filters'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import { spacing, typography } from '@/libs/theme'

const { Header, Sider, Content } = Layout

const Logo = styled.div`
  height: 32px;
  margin: ${spacing.md};
  display: flex;
  align-items: center;
  color: white;
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.bold};

  img {
    width: 32px;
    height: 32px;
    margin-right: ${spacing.sm};
  }
`

const StyledHeader = styled(Header)`
  padding: 0 ${spacing.md};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
`

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.md};
`

const UserName = styled.span`
  margin-right: ${spacing.sm};
`

const MainContent = styled(Content)`
  margin: ${spacing.md} ${spacing.md};
  padding: ${spacing.md};
  min-height: 280px;
  overflow: auto;
`

const SidebarMenu = () => {
  const [collapsed, setCollapsed] = useState(true)
  //const { token } = theme.useToken()
  const location = useLocation()

  const handleMouseEnter = useCallback(() => {
    setCollapsed(false)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setCollapsed(true)
  }, [])

  const selectMenu = useCallback(() => {
    const path = location.pathname
    if (path.startsWith('/dashboard')) return ['dashboard']
    if (path.startsWith('/stats')) return ['stats']
    if (path.startsWith('/account')) return ['account']
    if (path.startsWith('/settings')) return ['settings']
    if (path.startsWith('/subscriptions')) return ['subscriptions']
    if (path.startsWith('/surveys')) return ['surveys']
    return ['dashboard']
  }, [location.pathname])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        theme="dark"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectMenu()}
          style={{ marginTop: '100px' }}
          items={[
            {
              key: 'dashboard',
              icon: <DashboardOutlined />,
              label: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              key: 'stats',
              icon: <BarChartOutlined />,
              label: <Link to="/stats">Statistics</Link>,
            },
            {
              key: 'account',
              icon: <UserOutlined />,
              label: <Link to="/account">Account</Link>,
            },
            {
              key: 'settings',
              icon: <SettingOutlined />,
              label: <Link to="/settings">Settings</Link>,
            },
            {
              key: 'subscriptions',
              icon: <CreditCardOutlined />,
              label: <Link to="/subscriptions">Subscriptions</Link>,
            },
            {
              key: 'surveys',
              icon: <FormOutlined />,
              label: <Link to="/surveys">Surveys</Link>,
            },
          ]}
        />
      </Sider>

      <Layout
        style={{
          marginLeft: collapsed ? `${spacing.md}` : `${spacing.md}`,
          transition: 'all 0.2s',
        }}
      >
        <StyledHeader>
          <div></div>
          <UserSection>
            <LanguageSwitcher />
          </UserSection>
        </StyledHeader>
        <Filters />
        <MainContent>
          <Outlet />
        </MainContent>
      </Layout>
    </Layout>
  )
}

export default SidebarMenu
